import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

/**
 * Public address of the online results page, pushed from the desktop app as a
 * const socket so monitors can display a QR code for competitors.
 *
 * Deliberately NOT persisted (see the store's whitelist): a URL cached from a
 * previous competition would render a QR pointing at the wrong site for the few
 * seconds before the first const-emit replay arrives. Better to show nothing.
 */
interface PublicResultsState {
  url: string;
  label: string;
}

const initialState: PublicResultsState = {
  url: '',
  label: '',
};

const publicResultsSlice = createSlice({
  name: 'publicResults',
  initialState,
  reducers: {
    setPublicResults: (
      state,
      action: PayloadAction<{ url?: string; label?: string }>
    ) => {
      state.url = action.payload.url || '';
      state.label = action.payload.label || '';
    },
    clearPublicResults: (state) => {
      state.url = '';
      state.label = '';
    },
  },
});

export const { setPublicResults, clearPublicResults } =
  publicResultsSlice.actions;

export const selectPublicResultsUrl = (state: RootState) =>
  state.publicResults.url;
export const selectPublicResultsLabel = (state: RootState) =>
  state.publicResults.label;

export default publicResultsSlice.reducer;
